import React from 'react';
import _ from 'lodash';
import { parse, stringify } from 'query-string';
import {
  ClockIcon,
  DocumentArrowUpIcon,
  DocumentArrowDownIcon, FolderIcon
} from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import DropdownFilter from '../../components/DropdownFilter';

export default function SortBy(props) {
  const { location, history } = useRouter();

  const search = parse(location.search) || {};

  function onChange(order) {
    const search = parse(location.search) || {};

    search.order = order;
    delete search.page;

    history.push({
      pathname: location.pathname,
      search: stringify(_.extend({}, search))
    });
  }

  const orderMap = {
    Newest: {
      name: 'Newest',
      param: 'createdAt desc'
    },
    NameAscending: {
      name: 'Name (a-first)',
      param: 'firstName asc'
    },
    NameDescending: {
      name: 'Name (z-first)',
      param: 'firstName desc'
    },
    NetworksStewardedDescending: {
      name: 'Networks stewarded (most)',
      param: 'numberOfNetworksStewarded desc'
    },
    NetworksStewardedAscending: {
      name: 'Networks stewarded (least)',
      param: 'numberOfNetworksStewarded asc'
    },
  };

  const reverseOrderMap = _.mapKeys(orderMap, function(value, key) {
    return value.param;
  });

  return (
    <DropdownFilter subtitle="Sort by:" title={reverseOrderMap[search.order]?.name || 'Newest'}>
      <DropdownFilter.MenuItem
        icon={ClockIcon}
        title={orderMap.Newest.name}
        subtitle="Display recently created networks first."
        selected={!search.order || search.order === orderMap.Newest.param}
        onClick={() => onChange(orderMap.Newest.param)}
      />
      <DropdownFilter.MenuItem
        icon={DocumentArrowUpIcon}
        title={orderMap.NameAscending.name}
        subtitle="Display networks by name, starting with A."
        selected={search.order === orderMap.NameAscending.param}
        onClick={() => onChange(orderMap.NameAscending.param)}
      />
      <DropdownFilter.MenuItem
        icon={DocumentArrowDownIcon}
        title={orderMap.NameDescending.name}
        subtitle="Display networks by name, starting with Z."
        selected={search.order === orderMap.NameDescending.param}
        onClick={() => onChange(orderMap.NameDescending.param)}
      />
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.NetworksStewardedAscending.name}
        subtitle="Display stewards by the number of networks they steward (least)."
        selected={search.order === orderMap.NetworksStewardedAscending.param}
        onClick={() => onChange(orderMap.NetworksStewardedAscending.param)}
      />
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.NetworksStewardedDescending.name}
        subtitle="Display stewards by the number of networks they steward (most)."
        selected={search.order === orderMap.NetworksStewardedDescending.param}
        onClick={() => onChange(orderMap.NetworksStewardedDescending.param)}
      />
    </DropdownFilter>
  );
}
